<template>
  <v-container fluid>
    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
    <div class="d-flex flex-column justify-center align-center" v-if="state === 1">

      <div class="col-12 col-lg-6">
        <v-card tile flat>
          <v-card-text class="d-flex flex-column justify-center align-center text-center">
            <h2> {{ $t('pages.password.almostThere') }}</h2>
            <h3 class="mt-4">{{ $t('pages.password.choosePassword') }}</h3>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <div class="d-flex flex-column justify-center align-center">

      <div class="col-12 col-lg-6" v-if="!isLoading && state === 1">
        <v-card tile flat>
          <v-card-title class="d-flex justify-center align-center text-center">
            {{ $t('cards.titles.password') }}
          </v-card-title>
          <v-card-text>
            <v-text-field
                v-model="password"
                :label="$t('forms.password')"
                :rules="[rules.min, rules.upper, rules.lower, rules.special, rules.number]"
                :append-icon="showPassword ? 'fal fa-eye' : 'fal fa-eye-slash'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                counter
            ></v-text-field>
            <v-text-field
                class="mt-3"
                v-model="passwordRepeat"
                :label="$t('forms.passwordRepeat')"
                :rules="[rules.passwordMatch]"
                :append-icon="showPassword ? 'fal fa-eye' : 'fal fa-eye-slash'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                counter
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
                tile
                depressed
                color="primary"
                :disabled="!password"
                @click.prevent="complete"
            >
              {{ $t('buttons.complete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>

      <div class="col-12 col-lg-6" v-if="!isLoading && state === 2">
        <v-card tile flat>
          <v-card-title class="d-flex justify-center align-center text-center">
            {{ $t('cards.titles.congratulations') }}
          </v-card-title>
          <v-card-text class="text-center">
            <p>{{ $t('cards.titles.accountCreated') }}</p>
            <p></p>
            <v-btn
                block
                tile
                depressed
                color="primary"
                @click.prevent="go"
            >
              Make Your Move
            </v-btn>
          </v-card-text>
        </v-card>
      </div>

    </div>

  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
import maxios from "@/services/mediligo-axios";
export default {
  i18n: i18n,
  name: "m2h-password",
  props: ['session-id', 'ready'],
  components: {},
  data() {
    return {
      showPassword: false,
      isLoading: false,
      password: '',
      passwordRepeat: '',
      state: 1,
      passwordError: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Minstens 8 karakters',
        upper: v => /(?=.*[A-Z])/.test(v) || 'Minstens 1 hoofdletter',
        lower: v => /(?=.*[a-z])/.test(v) || 'Minstens 1 kleine letter',
        number: v => /(?=.*\d)/.test(v) || 'Moet een nummer bevatten',
        passwordMatch: () => {
          if (this.password === this.passwordRepeat) {
            return true
          } else {
            return 'Wachtwoorden komen niet overeen.'
          }
        }
      },
    }
  },
  mounted() {
  },

  methods: {
    go() {
      window.location.href = 'https://watch.movetohappiness.com/login';
    },
    async complete() {
      this.isLoading = true
      const res = await maxios.post("/api/onboarding/finalize", {
        session: this.sessionId,
        password: this.password
      });
      if (!res.data.success) {
        window.location.href = "/error";
      } else {
        if (!this.ready) {
          window.location.href = "/p1/" + this.sessionId;
        } else {
          this.state = 2
          this.isLoading = false
        }
      }
    }
  },
}
</script>

<style scoped>

</style>
